import { render, staticRenderFns } from "./Questionario.vue?vue&type=template&id=2f21b73c&scoped=true"
import script from "./Questionario.vue?vue&type=script&lang=js"
export * from "./Questionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21b73c",
  null
  
)

export default component.exports